<template>
  <div class="w-full mt-[10px] text-[16px] enterMessage">
    <div class="px-[18px]">
      <div class="w-full h-[1px] bg-white/15 mt-[13px] line"></div>
      <div class="flex flex-col mt-[25px] gap-[12px]">
        <span class="text-[#fff]/45 text-[15px] title">
          {{ $t("Saque.EnterMessage.TaxIDType") }}
        </span>
        <div :class="saqueType.length > 3 ? 'flex overflow-x-auto gap-3' : 'flex gap-3'"
          style="overflow-x: auto; white-space: nowrap">
          <van-button v-for="item in saqueType" :key="item.type" @click="
            choose = item;
          if (item.type.indexOf('CPF') == -1) {
            id = '';
          } else {
            idFocus = false;
          }
          " :class="[
            'w-[72px] h-[36px] rounded-lg text-[#fff] border-none bn',
            choose.type === item.type
              ? 'active_tab_btn'
              : 'bg-[var(--inner-table-bg-color40)] text-[#fff]/85',
          ]" style="flex-shrink: 0">
            {{ item.showName }}
          </van-button>
        </div>
      </div>

      <div class="flex flex-col mt-[15px]" v-if="choose.type !== 'CPF'">
        <div v-if="choose.value">
          <span class="text-[#fff]/45 text-[15px] block my-2">
            {{ choose.type }} {{ $t("Saque.EnterMessage.ID") }}
          </span>

          <div
            class="h-[44px] bg-[var(--inner-table-bg-color40)] flex items-center gap-[10px] pl-[50px] pr-[40px] rounded-[8px] relative overflow-hidden">
            <div class="absolute left-4 top-0 bottom-0 flex items-center justify-center">
              <Image class="size-[24px]" :src="bankCard" alt="" />
            </div>
            <span class="text-[15px]">{{ choose.value }}</span>
          </div>
        </div>
        <div v-else>
          <IconFormInput :label="choose.showName + ' ID'" :placeholder="choose.placeholder" v-model="id" :icon="choose.type == 'Email' ? mail : choose.type == 'PHONE' ? phone : bankCard
            " :errorMessage="(!choose.rules.includes(id.length) && idFocus) ||
              (choose.type === 'EVP' && !isValidEVP(id) && idFocus)
              ? choose.tips
              : ''
              " @input="
                (e) => {
                  id = e.target.value;
                  idFocus = true;
                  if (choose.type === 'Email') {
                    idFocus = !isValidEmail(id);
                  } else if (choose.type === 'EVP') {
                    idFocus = !isValidEVP(id);
                  } else if (choose.rules.includes(id.length)) {
                    idFocus = false;
                  }

                }
              " />
        </div>
      </div>

      <div class="flex flex-col mt-[12px] gap-[8px]">
        <div v-if="sharedData?.accountName">
          <span class="text-[#fff]/45 text-[15px] my-2 block">
            {{ $t("Saque.EnterMessage.BeneficiaryName") }}
          </span>
          <div class="h-[45px] bg-[var(--inner-table-bg-color40)] flex items-center gap-[10px] px-[18px] rounded-[8px]">
            <Image class="size-[24px]" :src="user" alt="" />
            <span class="text-[15px]">{{ sharedData?.accountName }}</span>
          </div>
        </div>
        <div v-else>
          <IconFormInput :label="$t('Saque.EnterMessage.BeneficiaryName')" :placeholder="commonType[0].placeholder"
            v-model="name" :icon="user" :errorMessage="''" @input="(e) => { }" />
        </div>
      </div>

      <div class="flex flex-col mt-[12px]">
        <div v-if="sharedData?.cpf">
          <span class="text-[#fff]/45 text-[15px] my-2 block"> {{ $t("meu.CPF") }} </span>
          <div class="h-[45px] bg-[var(--inner-table-bg-color40)] flex items-center gap-[10px] px-[18px] rounded-[8px]">
            <Image class="size-[24px]" :src="bankCard2" alt="" />
            <span class="text-[15px]">{{ sharedData?.cpf }}</span>
          </div>
        </div>
        <div v-else>
          <IconFormInput :label="$t('meu.CPF')" :placeholder="commonType[1].placeholder" v-model="cpfValue"
            :icon="bankCard2" :errorMessage="cpfValue.length !== 11 && cpfValueFocus ? commonType[1].tips : ''
              " @input="updateCpfValue" />
        </div>
      </div>

      <div class="text-[#fff]/50 van-popup--bottom fixed z-50 bg-[var(--theme-saque-btn-bg)]">
        <div class="px-4 py-[20px]">
          <van-button @click="_handleSaqueClick()" :disabled="idFocus ||
            !(
              getParams().accountNo &&
              getParams().accountName &&
              getParams().cpf.length === 11 &&
              sharedData.amount >= sharedData.limitMin
            )
  " class="primaryBtn">
            {{ $t("meu.Sake") }}
          </van-button>
        </div>
      </div>
      <van-popup v-if="showPassword" :close-on-click-overlay="false" v-model:show="showPassword"
        style="background: transparent; border: none; top: 30%">
        <SendPassword v-if="showPassword" @confirm="handleConfirm" @close="showPassword = false" />
      </van-popup>

      <div class="text-center text-[13px] leading-[18px] mt-[35px] my-[70px]">
        {{ $t("Saque.EnterMessage.AccurateContactInformation") }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import bankCard2 from "../images/bank.png";
import bankCard from "../images/bank.png";
import user from "../images/user.png";
import mail from "../images/email.png";
import phone from "../images/phone.png";
import IconFormInput from "@a/components/IconFormInput/index.vue";
import SendPassword from "./SendPassword.vue";
import { withdrawOrder } from "@/api/saque";
import { handleSaqueClick } from "@/utils/userStatusUtils";

const idFocus = ref(false);
const cpfValueFocus = ref(false);
const id = ref("");
const name = ref("");
const cpfValue = ref("");
const showPassword = ref(false);
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const choose = ref<any>({
  type: t("meu.CPF"),
  placeholder: t("Saque.EnterMessage.EnterYourCPFTips"),
  tips: t("Saque.EnterMessage.CPFRulesTips"),
  rules: [11],
  value: "",
});

const updateCpfValue = (e) => {
  cpfValueFocus.value = true;
  cpfValue.value = e.target.value.replace(/[^0-9]/g, "");
  if (cpfValue.value.length === 11) {
    cpfValueFocus.value = false;
  }
};

const sharedData: any = inject("sharedData");
// 校验密码成功 ,生成取款订单
const handleConfirm = async (password: string) => {
  try {
    const res: any = await withdrawOrder(getParams(password));
    sharedData.value.orderNo = res.data.merchantOrderNo;
    if (res.code == 1) {
      sharedData.value.showAmount = 2;
    } else {
      sharedData.value.showAmount = 3;
    }
    showPassword.value = false;
  } catch (error) {
    console.log(error);
  }
};

const router = useRouter();
const _handleSaqueClick = () => {
  handleSaqueClick(router, withdrawMoney);
};

//打开校验密码弹框
const withdrawMoney = async () => {
  window.scrollTo(0, 0);
  showPassword.value = true;
};
// 获取参数
const getParams = (password?: string) => {
  const params = {
    accountType: "PIX_" + choose.value.type.toUpperCase(),
    accountNo: choose.value.value ? choose.value.value : id.value,
    accountName: sharedData.value.accountName ? sharedData.value.accountName : name.value,
    cpf: sharedData.value.cpf ? sharedData.value.cpf : cpfValue.value,
    amount: sharedData.value.amount,
    rolling: sharedData.value.limitAmount,
    withdrawalPassword: password,
  };
  if (choose.value.type === "CPF") {
    params.accountNo = cpfValue.value || sharedData.value.cpf;
  }
  return params;
};
let saqueType;

const initializeSaqueType = () => {
  const supportTypesArr = sharedData.value.supportTypes?.split(",");
  const defaultarr = [
    {
      type: "CPF",
      showName: "CPF",
      placeholder: t("Saque.EnterMessage.EnterYourCPFTips"),
      tips: t("Saque.EnterMessage.CPFRulesTips"),
      rules: [11],
      value: sharedData.value.cpf ? sharedData.value.cpf : cpfValue.value,
    },
    {
      type: "Email",
      showName: "E-mail",
      placeholder: t("Saque.EnterMessage.EnterYourEmailTips"),
      tips: t("Saque.EnterMessage.EmailRulesTips"),
      rules: [36],
      value: sharedData.value.accountEmail ? sharedData.value.accountEmail : "",
    },
    {
      type: "PHONE",
      showName: "Telefone",
      placeholder: t("Saque.EnterMessage.EnterYourPhoneTips"),
      tips: t("Saque.EnterMessage.PhoneRulesTips"),
      rules: [10, 11],
      value: sharedData.value.accountMobile ? sharedData.value.accountMobile : "",
    },
    {
      type: "CNPJ",
      showName: "CNPJ",
      placeholder: t("Saque.EnterMessage.EnterYourCNPJTips"),
      tips: t("Saque.EnterMessage.CNPJRulesTips"),
      rules: [14],
      value: sharedData.value.accountCnpj ? sharedData.value.accountCnpj : "",
    },
    {
      type: "EVP",
      showName: "EVP",
      placeholder: t("Saque.EnterMessage.EnterYourEVPTips"),
      tips: t("Saque.EnterMessage.EVPRulesTips"),
      rules: [36],
      value: sharedData.value.accountEvp ? sharedData.value.accountEvp : "",
    },
  ];

  const arr = defaultarr.filter((item) => {
    if (supportTypesArr?.includes(item.type.toUpperCase()) || supportTypesArr?.includes(item.type.toLowerCase())) {
      return item;
    }
  });

  choose.value = arr[0];
  if (sharedData.value.accountCnpj && supportTypesArr?.includes("CNPJ")) {
    choose.value = arr.find((ele) => ele.type === "CNPJ");
  }
  if (sharedData.value.accountMobile && supportTypesArr?.includes("PHONE")) {
    choose.value = arr.find((ele) => ele.type === "PHONE");
  }
  if (sharedData.value.accountEmail && supportTypesArr?.includes("EMAIL")) {
    choose.value = arr.find((ele) => ele.type === "EMAIL");
  }
  if (sharedData.value.accountEvp && supportTypesArr?.includes("EVP")) {
    choose.value = arr.find((ele) => ele.type === "EVP");
  }
  if (sharedData.value.cpf && supportTypesArr?.includes("CPF")) {
    choose.value = arr.find((ele) => ele.type === "CPF");
  }
  saqueType = arr;
};

initializeSaqueType();

const commonType = [
  {
    type: "Nome do beneficiário",
    placeholder: t("Saque.EnterMessage.PleaseProvide"),
    value: sharedData.value.accountName ? sharedData.value.accountName : "",
  },
  {
    type: "CPF",
    placeholder: t("Saque.EnterMessage.EnterYourCPF"),
    tips: t("Saque.EnterMessage.CPFRulesTips"),
    value: sharedData.value.cpf ? sharedData.value.cpf : "",
  },
];

watch(cpfValue, (newVal) => {
  if (choose.value.type === "CPF" || choose.value.type === "Telefone") {
    id.value = newVal;
  }
});

// 校验邮箱
const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
// 校验EVP
const isValidEVP = (evp) => {
  const evpRegex = /^[0-9a-zA-Z]{8}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{12}$/;
  console.log(evpRegex.test(evp));
  return evpRegex.test(evp);
};

onMounted(() => {
  console.log(choose.value);
});
</script>

<style lang="scss" scoped></style>
